import { PropType } from 'vue';
import { Options, Vue } from 'vue-class-component';
import { GateDTO, GateMessageDTO } from '@/../client-generator/generated-clients/plants';
import DialogConfirmDelete from '@/views/components/DialogConfirmDelete/DialogConfirmDelete.vue';

@Options({
  name: 'messageItem',
  props: {
    message: {
      type: Object as PropType<GateMessageDTO>,
      required: true,
    },
    plantGates: {
      type: Array as PropType<GateDTO[]>,
      required: true,
    },
    offline: {
      type: Boolean,
      required: false,
      default: false
    },
    expired: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: { DialogConfirmDelete },
  emits: ['edit-message', 'delete-message'],
})
export default class MessageItem extends Vue {
  message!: GateMessageDTO;
  isVisibleDeleteMessageConfirm = false;
  offline!: boolean;
  plantGates!: GateDTO[];
  expired!: boolean;

  getValidTime() {
    const dateFrom = this.getParsedDate(this.message.durationSince!, 'date');
    const dateTo = this.getParsedDate(this.message.durationUntil!, 'date');
    const hourFrom = this.getParsedDate(this.message.durationSince!, 'time');
    const hourTo = this.getParsedDate(this.message.durationUntil!, 'time');
    return `${dateFrom} h ${hourFrom} - ${dateTo} h ${hourTo}`;
  }

  get gates() {
    const gates = this.plantGates.filter((gate) => this.message.gateIds!.includes(gate.gateId!));
    return gates.map((gate) => gate.name).join(', ').toLocaleUpperCase();
  }

  getParsedDate(date: Date, type: 'date' | 'time') {
    if (!date) return '-';
    const optionsDate: any = {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      timeZone: 'Utc',
    };
    const optionsTime: any = {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Utc',
    };
    return date.toLocaleString(navigator.language, type === 'date' ? optionsDate : optionsTime);
  }

  handleEditMessage() {
    this.$emit('edit-message', this.message);
  }

  toggleDeleteMessageConfirm() {
    this.isVisibleDeleteMessageConfirm = !this.isVisibleDeleteMessageConfirm;
  }

  async handleDeleteMessage() {
    this.$emit('delete-message', this.message.id);
  }

}
